import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import { uniq } from 'lodash'
import type ReStudentSummaryReportingRoute from 'teacher-ui-client/reporting/ui-scope/re/student-summary/route'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type { NormalizedInterval } from 'date-fns'
import type ReStudentSummaryCourseProgressSpellingController from 'teacher-ui-client/reporting/ui-scope/re/student-summary/course-progress/spelling/controller'
import type StudentEventsService from 'teacher-ui-client/services/student-events'
import type LessonInfoService from 'teacher-ui-client/services/lesson-info'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import { isPresent } from '@ember/utils'

export default class ReStudentSummaryCourseProgressSpellingRoute extends Route {
  @service studentEvents!: StudentEventsService

  @service lessonInfo!: LessonInfoService

  queryParams = {
    currentMapNumber: {
      refreshModel: false,
      replace: true,
    },
  }

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor(
      'reporting.ui-scope.re.student-summary',
    ) as ModelFor<ReStudentSummaryReportingRoute>

    const statsScope: StudentScope = { scope: 'student', ids: [student.id] }

    const product: LegacyProductRe = 're'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      student,
      students: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests(product: LegacyProductRe, scope: StudentScope, period: NormalizedInterval) {
    return RSVP.hash({
      spellingMapDetails: this.studentEvents.spellingMapDetails(product, scope, period),
      spellingLessonDetails: this.studentEvents.spellingLessonDetails(product, scope, period),
    })
  }

  setupController(
    controller: ReStudentSummaryCourseProgressSpellingController,
    model: ModelFor<ReStudentSummaryCourseProgressSpellingRoute>,
  ) {
    const lessons = this.lessonInfo.lessonsFor(Precinct.RE_SPELLING)
    const lessonsData = model.spellingLessonDetails ?? []

    const unsortedMapNumbers = uniq(
      lessonsData
        .map((lessonData) => {
          const lessonItem = lessons.find((lessonInfo) => lessonInfo.lesson_position === lessonData.lesson_number)
          return lessonItem?.map ?? null
        })
        .filter(isPresent),
    )

    const mapNumbers = unsortedMapNumbers.sort(function (a, b) {
      return a - b
    })
    controller.mapNumbersWithLessonsCompleted = mapNumbers

    const [firstMapNumber] = mapNumbers
    const { currentMapNumber } = controller

    const currentMapNumberValid = mapNumbers.includes(currentMapNumber)
    if (!currentMapNumberValid) {
      controller.currentMapNumber = firstMapNumber
    }

    super.setupController(controller, model)
  }
}
